import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { } from 'antd';
import { connect } from 'react-redux';
import { intlShape, injectIntl } from 'react-intl';
import Enums from 'utils/EnumsManager';
import { ReportFilters, ReportPreview } from 'views/index';


const defaultProps = {};
const propTypes = {
  intl: intlShape.isRequired,
};

class RightPanels extends PureComponent {
  componentDidMount() { }

  render() {
    return (
      <Fragment>
        <ReportFilters />
        <ReportPreview />
      </Fragment>
    );
  }
}

RightPanels.defaultProps = defaultProps;
RightPanels.propTypes = propTypes;
export default injectIntl(RightPanels);



// WEBPACK FOOTER //
// ./src/views/ReportSetup/components/RightPanels.jsx